/* partners-visitor.js —— 把访客 id 送进订单
   --------------------------------------------------------------------------
   放进主题：`assets/partners-visitor.js`，并在 `layout/theme.liquid` 的
   `</body>` 之前加一行：
       <script src="{{ 'partners-visitor.js' | asset_url }}" defer></script>

   ⭐ 它做的事只有一件：把 Worker 种下的 `_pv` cookie 写进 **cart attributes**，
   这样它会跟着订单走到 `note_attributes`，Partners 那边就能把订单和
   `link_touches` 里的触点连起来（`lib/attribution.ts`）。

   ⚠️ **不在这里生成访客 id。** id 由 Worker 在 302 跳转那一刻用 `Set-Cookie`
   种下 —— Safari ITP 把【脚本写的】cookie 压到 7 天，而 ebike 的决策周期是
   数周到数月。这里生成一个，等于把那条限制又请回来了。
   读不到 cookie 就什么都不做：那说明这个人不是从跟踪链接来的，本来就没有触点。

   ⚠️ **不是每次都写购物车。** `/cart/update.js` 是一次真实的写操作，
   每个页面都打一次既浪费又会跟别的脚本抢购物车。只在【还没写过】或者
   【写的跟 cookie 不一样】时才写。
   -------------------------------------------------------------------------- */
(function () {
  var KEY = '_pv';

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  var vid = cookie(KEY);
  /* 形状跟 Partners 那边的检查一致（`/^[A-Za-z0-9_-]{8,64}$/`）。
     对不上就当没有 —— 宁可少一条触点，也不要往购物车里写一个脏值。 */
  if (!/^[A-Za-z0-9_-]{8,64}$/.test(vid)) return;

  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      if (!cart) return;
      if (cart.attributes && cart.attributes[KEY] === vid) return;   // 已经是对的，不动
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        /* ⚠️ 属性名就是 `_pv`。Partners 那边认三个键
           （`partners_visitor_id` / `visitor_id` / `_pv`，见 shopify-events.ts
           的 VISITOR_KEYS），改名字要两边一起改。
           下划线开头的属性在结账页面上**不显示给顾客**，正合适。 */
        body: JSON.stringify({ attributes: (function () { var a = {}; a[KEY] = vid; return a; })() })
      });
    })
    .catch(function () { /* 归因是锦上添花，绝不能让它挡住页面 */ });
})();
